<mat-dialog-content>
  <h2 mat-dialog-title>{{ 'STORE.DECLINE_ORDER.TITLE' | translate }}</h2>
  <p>{{ 'STORE.DECLINE_ORDER.DETAILS' | translate }}</p>
  <mat-form-field>
    <input
      matInput
      [formControl]="message"
      data-testid="decline-reason-input"
      placeholder="{{ 'FRONTEND.SALES_UI.MESSAGE' | translate }}"
      required
    />
    @if (message.invalid) {
      <mat-error>{{ getErrorMessage() }}</mat-error>
    }
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <button
    mat-raised-button
    color="warn"
    data-testid="dialog-decline-button"
    [disabled]="declineLoading"
    (click)="onDecline()"
  >
    {{ 'FRONTEND.SALES_UI.DECLINE' | translate }}
  </button>
  <button mat-button color="primary" mat-dialog-close>
    {{ 'FRONTEND.SALES_UI.CANCEL' | translate }}
  </button>
</mat-dialog-actions>
